<script lang="ts">
  import { Button, Col, Form, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from "sveltestrap";
  import { BasicInputgroups, Cancel, JointAddon, LeftAddon, LeftRightAddon, Raisestyle, RightAddon, Solidstyle, Squarestyle, Submit } from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
</script>
<Card cardHeaderprops="pb-0" headerTitle={BasicInputgroups}>
    <div slot=contentbody>
      <Row>
        <Col>
          <Form>
            <FormGroup class="m-form__group">
              <Label>{LeftAddon}</Label>
              <InputGroup>
                <InputGroupText>@</InputGroupText>
                <Input placeholder="Email" />
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <Label>{RightAddon}</Label>
              <InputGroup>
                <Input placeholder="Recipient's username" />
                <InputGroupText>@example.com</InputGroupText>
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <Label>{JointAddon}</Label>
              <InputGroup>
                <InputGroupText>$</InputGroupText>
                <InputGroupText>0.00</InputGroupText>
                <Input  />
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <Label>{LeftRightAddon}</Label>
              <InputGroup>
                <InputGroupText>$ </InputGroupText>
                <Input  />
                <InputGroupText>.00</InputGroupText>
              </InputGroup>
            </FormGroup>
            <FormGroup class="input-group-solid">
              <Label>{Solidstyle}</Label>
              <InputGroup>
                <InputGroupText>@ </InputGroupText>
                <Input placeholder="Email" />
              </InputGroup>
            </FormGroup>
            <FormGroup class="input-group-square">
              <Label>{Squarestyle}</Label>
              <InputGroup>
                <InputGroupText>+</InputGroupText>
                <Input placeholder="Email" />
              </InputGroup>
            </FormGroup>
            <FormGroup class="input-group-square">
              <Label>{Raisestyle}</Label>
              <InputGroup>
                <InputGroupText>#</InputGroupText>
                <Input placeholder="Email" />
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <Label>{LeftRightAddon}</Label>
              <InputGroup>
                <InputGroupText>$ </InputGroupText>
                <Input placeholder="Email" />
                <InputGroupText>.00</InputGroupText>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </div>
    <div slot="contentfooter">
      <Button color="primary" class="m-r-15" type="submit">{Submit}</Button>
      <Button color="light" type="submit">{Cancel}</Button>
    </div>
</Card>